/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveItemsDto } from '../../models/remove-items-dto';

export interface FolderControllerRemoveItems$Params {
  folderId: string;
      body: RemoveItemsDto
}

export function folderControllerRemoveItems(http: HttpClient, rootUrl: string, params: FolderControllerRemoveItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, folderControllerRemoveItems.PATH, 'delete');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

folderControllerRemoveItems.PATH = '/folder/items/{folderId}';
